import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import * as Notifications from 'expo-notifications';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

import TabBarIcon from '../components/TabBarIcon';
import VisitScreen from '../screens/VisitScreen';
import PantriesScreen from '../screens/PantriesScreen';
import UpdateScreen from '../screens/UpdateScreen';
import ProfileScreen from '../screens/ProfileScreen';
import LanguageScreen from '../screens/register/LanguageScreen';
import Colors from '../constants/Colors';
import Plentiful from '../constants/Plentiful';
import { useLocalization } from '../store/utils/useLocalization';

const BottomTab = createBottomTabNavigator();
const INITIAL_ROUTE_NAME = 'pantries';

export default function BottomTabNavigator({ navigation, route }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isEmbed, setIsEmbed] = useState(false);

  useEffect(() => {
    if (Platform.OS == 'web') {
      if (window.location !== window.parent.location) {
        setIsEmbed(true);
      }
    }

    const handleNotification = (data) => {
      if (data.route) {
        if (data.route.substring(0, 1) === '/') {
          data.route = data.route.substring(1);
        }
        const routeParts = data.route.split('/');
        switch (routeParts[0]) {
          case 'visits':
            navigation.navigate('visits');
            break;
          case 'messages':
            navigation.navigate('updates');
            break;
          case 'pantry':
          case 'pantries':
            navigation.navigate('pantries', { pantryId: routeParts[1] });
            break;
          default:
            break;
        }
      }
    };
    // for when app is not open
    if (Platform.OS !== 'web') {
      const subscription = Notifications.addNotificationResponseReceivedListener((response) => {
        const data = response.notification.request.content.data;
        handleNotification(data);
      });
      // for when app is open
      // const whenInApp = Notifications.addNotificationReceivedListener(notification => {
      //   const data = notification?.request?.content?.data;
      //   handleNotification(data);
      // });
      return () => {
        subscription.remove();
        // whenInApp.remove();
      };
    }
  }, []);

  const user = useSelector((state) => state.registration.user);
  const { translation } = useLocalization();

  const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (isEmbed) {
    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <BottomTab.Navigator
            initialRouteName={INITIAL_ROUTE_NAME}
            screenOptions={{ title: Plentiful.TITLE }}
            tabBarOptions={{
              activeTintColor: Colors.white,
              activeBackgroundColor: Colors.primaryColor,
              inactiveTintColor: Colors.lightGray,
              inactiveBackgroundColor: Colors.primaryColor,
              style: {
                backgroundColor: Colors.primaryColor,
                paddingBottom: 0,
                height: 0,
              },
            }}
          >
            <BottomTab.Screen
              name="pantries"
              component={PantriesScreen}
              options={{
                tabBarTestID: 'menu-pantries',
              }}
            />
          </BottomTab.Navigator>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }

  return (
    <SafeAreaInsetsContext.Consumer>
      {(insets) => (
        <BottomTab.Navigator
          initialRouteName={INITIAL_ROUTE_NAME}
          screenOptions={{
            title: Plentiful.TITLE,
            headerShown: false,
            tabBarActiveTintColor: Colors.white,
            tabBarActiveBackgroundColor: Colors.primaryColor,
            tabBarInactiveTintColor: Colors.lightGray,
            tabBarInactiveBackgroundColor: Colors.primaryColor,
            tabBarStyle: {
              backgroundColor: Colors.primaryColor,
              paddingBottom: 6 + insets.bottom,
              height: 56 + insets.bottom,
            },
          }}
        >
          <BottomTab.Screen
            name="pantries"
            component={PantriesScreen}
            options={{
              tabBarLabel: capitalize(translation.fragment_main_bottombar_pantries),
              tabBarIcon: ({ focused }) => (
                <TabBarIcon focused={focused} type="MaterialIcons" name="location-on" />
              ),
              tabBarTestID: 'menu-pantries',
            }}
          />
          {user.id ? (
            <BottomTab.Screen
              name="visits"
              component={VisitScreen}
              options={{
                tabBarLabel: capitalize(translation.fragment_main_bottombar_visits),
                tabBarIcon: ({ focused }) => <TabBarIcon focused={focused} name="bell" />,
                unmountOnBlur: true,
                tabBarTestID: 'menu-visits',
              }}
            />
          ) : null}
          {user.id ? (
            <BottomTab.Screen
              name="updates"
              component={UpdateScreen}
              options={{
                tabBarLabel: capitalize(translation.updates),
                tabBarIcon: ({ focused }) => <TabBarIcon focused={focused} name="message-alert" />,
                unmountOnBlur: true,
                tabBarTestID: 'menu-updates',
              }}
            />
          ) : null}
          {user.id ? (
            <BottomTab.Screen
              name="profile"
              component={ProfileScreen}
              options={{
                tabBarLabel: capitalize(translation.fragment_main_bottombar_profile),
                tabBarIcon: ({ focused }) => (
                  <TabBarIcon focused={focused} type="MaterialIcons" name="person" />
                ),
                tabBarTestID: 'menu-profile',
              }}
            />
          ) : (
            <BottomTab.Screen
              name="language"
              component={LanguageScreen}
              options={{
                tabBarLabel: capitalize(translation.sign_in),
                tabBarIcon: ({ focused }) => (
                  <TabBarIcon focused={focused} type="MaterialIcons" name="person" />
                ),
                tabBarTestID: 'menu-language',
              }}
            />
          )}
        </BottomTab.Navigator>
      )}
    </SafeAreaInsetsContext.Consumer>
  );
}
